import './export-modal.html';
import {FILE_TYPE} from "../../services/export/ExportService";

export const EXPORT_TYPE = {
    CSV: {
        value: 'CSV',
        method: 'downloadCSV',
        userFunction: FILE_TYPE.CSV.userFunction,
        mapFileName: FILE_TYPE.CSV.mapFileName,
    },
    XLSX: {
        value: 'XLSX',
        method: 'downloadXls',
        userFunction: FILE_TYPE.XLSX.userFunction,
        mapFileName: FILE_TYPE.XLSX.mapFileName,
    },
    XLS: {
        value: 'XLS',
        method: 'downloadXls',
        userFunction: FILE_TYPE.XLS.userFunction,
        mapFileName: FILE_TYPE.XLS.mapFileName,
    },
    PDF_ACCOUNT_OVERVIEW: {
        method: 'downloadPDF',
        url: '/accounts',
        value: 'PDF_ACCOUNT_OVERVIEW',
        prefix: 'Account_List_',
        userFunction: FILE_TYPE.PDF.userFunction,
        mapFileName: FILE_TYPE.PDF.mapFileName,
    }
};

export const TXT_TYPE= 'TXT';
export const PDF_TYPE= 'PDF';

/** @ngInject */
export class ExportModalController {
    constructor($rootScope, $mdDialog, sessionPersistance, exportModalBean) {
        this.$rootScope = $rootScope;
        this.modalInstance = $mdDialog;
        this.supportedExports = exportModalBean.supportedExports;
        this.selectedExport = this.supportedExports[0].value;
        this.exportModalBean = exportModalBean;
        this.sessionPersistance = sessionPersistance;
    }

    confirm() {
        const modelBeanParams = this.exportModalBean.params || {};
        const paramsAttributes = {reportType: EXPORT_TYPE[this.selectedExport],
            userFunction: EXPORT_TYPE[this.selectedExport].userFunction,
            group: this.exportModalBean.group};
        const params = Object.assign(modelBeanParams, paramsAttributes);
        this.$rootScope.$broadcast(this.$rootScope.checkElements && (this.exportModalBean.group === undefined || !this.exportModalBean.group.$hideTable) ?
            'export' : 'exportGroup', params);
        return this.modalInstance.hide();
    }

    exportGroupsAndChecks(params) {
        this.$rootScope.groupsSelected.forEach((group) => {
            params.group = group;
            this.$rootScope.$broadcast('exportGroup', params);
        });

        if(this.$rootScope.checkElements) {
            this.$rootScope.$broadcast('export', params);
        }
    }

    closeDialog() {
        return this.modalInstance.cancel();
    }
}
